import { reactive } from 'vue'
import md5 from "@/script/md5"

const cacheStorage = new Map()

const loading = reactive({})

function save (identifier, data) {
    if (typeof data !== 'object') {
        throw 'Can store only objects'
    }

    for (const i in data) {
        const key = md5(i + identifier)
        cacheStorage.set(key, { created: new Date(), value: data[i] })
    }
}

/**
 *
 * @param {string} identifier
 * @param {array} keys
 * @param {integer} age Опционально. Возраст в милисекундах (вернуть кеш, если не старше указанного возраста)
 * @returns
 */
function read (identifier, keys, age) {
    if (!Array.isArray(keys)) {
        throw 'Restore list must be array'
    }

    const resolved = {}
    const notfound = []
    for (const i in keys) {
        const key = md5(keys[i] + identifier)
        if (cacheStorage.has(key)) {

          if (age) {
            const diff = new Date() - cacheStorage.get(key).created
            if (diff > age) {
              notfound.push(keys[i])
              cacheStorage.delete(key)
              continue
            }
          }

          resolved[keys[i]] = cacheStorage.get(key).value
        } else {
          notfound.push(keys[i])
        }
    }

    return { resolved, notfound }
}

function remove (identifier, keys) {
  if (!Array.isArray(keys)) {
    throw 'Remove list must be array'
  }

  keys.forEach(item => {
    cacheStorage.delete(md5(item + identifier))
  })
}

export default function (cacheName) {
  return {
    save: data => {
      save(cacheName, data)
      loading[cacheName] = undefined
    },
    read: (keys = [], age) => read(cacheName, keys, age),
    remove: (keys = []) => remove(cacheName, keys),
    loading,
    stop: (customCacheName) => loading[customCacheName ?? cacheName] = undefined
  }
}